import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../../styles/scss/style.css';

//Components
import FormLabel from '../atoms/FormLabel';
import FormTextfield from '../atoms/FormTextfield';
import FormErrorMessage from '../atoms/FormErrorMessage';

//Returning the component
class LabeledTextfield extends Component {
	render() {
		return (
			<div className={`form__group ${this.props.formGroupClassType}`}>
				<FormLabel for={this.props.labelFor} text={this.props.labelText} id={this.props.labelId} />
				<FormTextfield 
					classType={this.props.textfieldClassType}
					id={this.props.textfieldId}
					placeholder={this.props.textfieldPlaceholder}
					type={this.props.inputType}
					name={this.props.textfieldName}
					value={this.props.value}
					onChange={this.props.onChange}
					onBlur={this.props.onBlur}
					required={this.props.required} 
				/>
				<FormErrorMessage classType={this.props.errorMessageClassType} text={this.props.errorMessageText} />
			</div>
		)
	}
}

LabeledTextfield.propTypes = {
	formGroupClassType: PropTypes.string,
	labelFor: PropTypes.string,
	labelText: PropTypes.string,
	labelId: PropTypes.string,
	textfieldClassType: PropTypes.string,
	textfieldId: PropTypes.string,
	textareaPlaceholder: PropTypes.string,
	textfieldPlaceholder: PropTypes.string,
	textfieldName: PropTypes.string,
	errorMessageClassType: PropTypes.string,
	errorMessageText: PropTypes.string
}

export default LabeledTextfield;




// WEBPACK FOOTER //
// ./src/redux/components/molecules/LabeledTextfield.jsx